/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoRaffleListListData model module.
 * @module model/EventsControllerDtoRaffleListListData
 * @version 1.0
 */
class EventsControllerDtoRaffleListListData {
    /**
     * Constructs a new <code>EventsControllerDtoRaffleListListData</code>.
     * @alias module:model/EventsControllerDtoRaffleListListData
     */
    constructor() { 
        
        EventsControllerDtoRaffleListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoRaffleListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoRaffleListListData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoRaffleListListData} The populated <code>EventsControllerDtoRaffleListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoRaffleListListData();

            if (data.hasOwnProperty('raffleNo')) {
                obj['raffleNo'] = ApiClient.convertToType(data['raffleNo'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('itemDrawStartAt')) {
                obj['itemDrawStartAt'] = ApiClient.convertToType(data['itemDrawStartAt'], 'Date');
            }
            if (data.hasOwnProperty('itemDrawEndAt')) {
                obj['itemDrawEndAt'] = ApiClient.convertToType(data['itemDrawEndAt'], 'Date');
            }
            if (data.hasOwnProperty('ticketRequiredCount')) {
                obj['ticketRequiredCount'] = ApiClient.convertToType(data['ticketRequiredCount'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('roundNo')) {
                obj['roundNo'] = ApiClient.convertToType(data['roundNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoRaffleListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoRaffleListListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} raffleNo
 */
EventsControllerDtoRaffleListListData.prototype['raffleNo'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoRaffleListListData.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoRaffleListListData.prototype['endAt'] = undefined;

/**
 * @member {Date} itemDrawStartAt
 */
EventsControllerDtoRaffleListListData.prototype['itemDrawStartAt'] = undefined;

/**
 * @member {Date} itemDrawEndAt
 */
EventsControllerDtoRaffleListListData.prototype['itemDrawEndAt'] = undefined;

/**
 * @member {Number} ticketRequiredCount
 */
EventsControllerDtoRaffleListListData.prototype['ticketRequiredCount'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoRaffleListListData.prototype['createdAt'] = undefined;

/**
 * @member {Number} roundNo
 */
EventsControllerDtoRaffleListListData.prototype['roundNo'] = undefined;






export default EventsControllerDtoRaffleListListData;

